import React from 'react';

function Azerbaijan(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124194)">
        <mask
          id="mask0_800_124194"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124194)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#AF0100"
          />
          <mask
            id="mask1_800_124194"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124194)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#3CA5D9"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#73BE4A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.2822 15.0239C17.7668 14.7134 16.4364 13.5539 16.4521 12C16.4668 10.5454 17.4297 9.36784 19.0964 9.03345C20.763 8.69905 22.491 9.33448 22.491 9.33448C22.0317 8.42657 20.4326 7.78992 19.1209 7.79298C16.6794 7.79867 14.0746 9.4555 14.049 11.9856C14.0225 14.6086 16.8309 16.0999 19.3026 16.0941C21.2841 16.0895 22.2254 14.9559 22.4207 14.4739C22.4207 14.4739 20.7975 15.3345 19.2822 15.0239ZM20.2697 13.4207L21.5923 12.6027L22.9148 13.4207L22.4482 12.0499L23.7321 11.1846L22.1213 11.1554L21.5923 9.80266L21.0633 11.1554L19.4524 11.1846L20.7363 12.0499L20.2697 13.4207Z"
              fill="#F7FCFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124194">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Azerbaijan;
